import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { supabase } from '../../lib/supabase';

export const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Handle the OAuth callback
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth callback error:', error);
          navigate('/auth', { 
            state: { error: 'Authentication failed. Please try again.' } 
          });
          return;
        }

        if (data.session) {
          // Get the intended destination from state, or default to home
          const from = location.state?.from?.pathname || '/';
          navigate(from, { replace: true });
        } else {
          navigate('/auth');
        }
      } catch (err) {
        console.error('Unexpected error during auth callback:', err);
        navigate('/auth', { 
          state: { error: 'An unexpected error occurred. Please try again.' } 
        });
      }
    };

    handleAuthCallback();
  }, [navigate, location]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress size={40} />
      <Typography variant="body1" sx={{ mt: 2 }}>
        Completing authentication...
      </Typography>
    </Box>
  );
};